<template>
  <div class="pp-map" :class="{ 'pp-map--is-visible': visible }">
    <gmap-map
      ref="map"
      :options="options"
      :center="mapCenter"
      class="pp-map__map"
      @click="handleClick"
      @tilesloaded="$emit('loaded')"
    >
      <gmap-marker
        :visible="isMarkerVisible"
        :icon="markerIcon"
        :position="markerPosition"
      />
    </gmap-map>
    <div class="pp-map__overlay"/>
    <overlay type="map"/>
    <transition name="fade">
      <zoom-control
        v-if="isActive"
        @up="handleZoomIn"
        @down="handleZoomOut"
      />
    </transition>
  </div>
</template>

<script>
import Overlay from '@/components/Overlay'
import ZoomControl from '@/components/ZoomControl'

export default {
  components: {
    Overlay,
    ZoomControl
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    center: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    isMarkerVisible: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    },
    markerPosition: {
      type: Object,
      required: true
    },
    markerIcon: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      mapCenter: {},
      mapObject: false
    }
  },
  watch: {
    center () {
      this.$refs.map.$mapPromise.then(map => {
        // eslint-disable-next-line
        map.panTo(this.center)
      })
    }
  },
  created () {
    this.mapCenter = this.center
  },
  mounted () {
    this.$refs.map.$mapPromise.then(map => {
      this.mapObject = map
      this.$emit('mount', map)
    })
  },
  methods: {
    handleClick ({ latLng = {} } = {}) {
      const coords = !!latLng.lat && { lat: latLng.lat(), lng: latLng.lng() }
      this.$emit('click', coords)
    },
    handleZoomIn () {
      if (!this.mapObject) return
      this.mapObject.setZoom(this.mapObject.getZoom() + 1)
    },
    handleZoomOut () {
      if (!this.mapObject) return
      this.mapObject.setZoom(this.mapObject.getZoom() - 1)
    }
  }
}
</script>

<style lang="scss" scoped>
  .pp-map {
    @include full-size(fixed);

    background-color: #c51414;
    z-index: z(hidden);
    opacity: 0;
    pointer-events: none;
    transition: opacity .4s,
                z-index .01s ease .4s;

    &--is-visible {
      z-index: z(submit-map);
      opacity: 1;
      pointer-events: auto;
      transition: opacity .4s;
    }

    &__map {
      @include full-size;
    }

    &__overlay {
      @include full-size;

      mix-blend-mode: screen;
      background-image: url('/img/noise-pattern-alpha.png');
      pointer-events: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/PlacePicker/PlacePickerMap.vue